import Base from "@/api/Base";

export default class GetList extends Base
{
	setType (v)
	{
		this.data.type = v;
		return this;
	}

	setStatus (v)
	{
		this.data.status = v;
		return this;
	}

	setOffset (v)
	{
		this.data.offset = v;
		return this;
	}

	setLimit (v)
	{
		this.data.limit = v;
		return this;
	}

	getMethod ()
	{
		return 'GET';
	}

	getUrl ()
	{
		return '/transaktion';
	}
}
